module.exports = __webpack_public_path__ + "static/aginix-icon-header-6fb15cc0248ca459d21e0848c8a43a0d.png";